import { ReactNode } from 'react';

interface CenteredLayoutProps {
  title?: string;
  subtitle?: string;
  children: ReactNode;
}

export function CenteredLayout({ title = "Sign in to Promo", subtitle, children }: CenteredLayoutProps) {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 bg-background">
      <div className="w-full max-w-md space-y-6 sm:space-y-8">
        <div className="flex justify-center">
          <img
            src="/tebra-logo.svg"
            alt="Tebra Logo"
            className="h-12 w-auto"
            aria-hidden="true"
          />
        </div>
        <div className="text-center">
          <h1 className="heading-mobile">{title}</h1>
          {subtitle && <p className="mt-2 text-gray-600">{subtitle}</p>}
        </div>
        {children}
      </div>
    </div>
  );
} 